import { render, staticRenderFns } from "./Collaboration.vue?vue&type=template&id=5d1c933c"
import script from "./Collaboration.vue?vue&type=script&lang=js"
export * from "./Collaboration.vue?vue&type=script&lang=js"
import style0 from "./Collaboration.vue?vue&type=style&index=0&id=5d1c933c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports